<template>
  <form ref="searchForm" @submit.prevent="searchItems">
    <div class="row mx-0">
      <div class="col-sm-12">
        <div class="d-flex justify-content-center align-items-center gap-3">
          <div>
            <b-form-group :label="label">
              <b-form-input
                :disabled="itemDetails"
                type="text"
                v-model="searchForm.query"
                placeholder="Name / description"
              />
            </b-form-group>
            <span class="error">{{ searchErrors.query }}</span>
            <div
              id="suggestedItems"
              v-if="suggestedItems && suggestedItems.length"
            >
              <!-- Item Details -->
              <div v-if="itemDetails" class="item-details mt-1">
                Selected:
                <b> {{ getItemName(itemDetails.locales) || "No Name" }}</b>
              </div>

              <ul v-else class="suggested-items-wrapper list list-group">
                <li
                  class="list-group-item"
                  v-for="(suggestedItem, index) in suggestedItems"
                  :key="index"
                  @click="() => selectItem(suggestedItem)"
                >
                  {{ getItemName(suggestedItem.locales) || "No Name" }}
                </li>
              </ul>
            </div>
          </div>
          <div class="mt-2 ml-2">
            <b-button
              v-if="itemDetails"
              type="button"
              variant="warning"
              @click="resetSearch()"
            >
              <i class="las la-sync fa-lg"></i>
            </b-button>
            <b-button v-else type="submit" variant="primary">
              <i class="las la-search fa-lg"></i>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { searchItems } from "@/API/ItemsAPIs";
import { submitAndNotify } from "@/helpers/utils";

export default {
  name: "SearchItemsForm",
  props: {
    businessId: {
      type: Number,
      default: null
    },
    branchId: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: "Name / Phone"
    },
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isCreateItem: false,
      itemDetails: null,
      suggestedItems: [],
      searchForm: {
        query: ""
      },
      searchErrors: {
        query: ""
      }
    };
  },

  methods: {
    getItemName(locales) {
      return locales?.find(locale => locale.locale === this.$i18n.locale)?.name;
    },
    async searchItems() {
      if (!this.businessId) {
        console.error("businessId is null, make sure it's passed correctly!");
        return;
      }
      this.searchErrors.query = "";
      if (this.isRequired && !this.searchForm.query)
        return (this.searchErrors.query = "This field is required, ");
      if (!this.searchForm.query) return;

      const searchData = {
        businessId: this.businessId,
        branchId: this.branchId,
        search: this.searchForm.query
      };
      const errorMessage = "No chalets found with " + this.searchForm.query;
      const callback = response => {
        this.suggestedItems = response.data;
      };

      submitAndNotify(
        this,
        searchItems(searchData),
        callback,
        "",
        errorMessage
      );
    },
    resetSearch() {
      this.itemDetails = null;
      this.suggestedItems = null;
      this.searchForm.query = null;
      this.$emit("setItem", null);
    },
    selectItem(item) {
      this.itemDetails = item;
      this.$emit("setItem", item);
    }
  }
};
</script>

<style scoped>
.item-details {
  background: #fff;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.suggested-items-wrapper {
  position: absolute;
  background: #fff;
  padding: 10px;
  max-width: 300px;
  opacity: 0.9;
  z-index: 1000;
}

.quick-add {
  position: absolute;
  right: 0;
  z-index: 3;
}
</style>
